/* tslint:disable */
/* eslint-disable */
/**
 * Consolidate Legacy API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetTodoRequest
 */
export interface GetTodoRequest {
    /**
     * 
     * @type {number}
     * @memberof GetTodoRequest
     */
    limit?: number;
    /**
     * 
     * @type {number}
     * @memberof GetTodoRequest
     */
    offset?: number;
    /**
     * 
     * @type {number}
     * @memberof GetTodoRequest
     */
    showFuture?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetTodoRequest
     */
    divider?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GetTodoRequest
     */
    todotype?: GetTodoRequestTodotypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GetTodoRequest
     */
    getcount?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GetTodoRequest
     */
    hash?: number;
}

/**
* @export
* @enum {string}
*/
export enum GetTodoRequestTodotypeEnum {
    ToDo = 0,
    Waiting = 1,
    ReadingMaterial = 2,
    PermanentDocument = 3,
    Private = 4,
    WaitingForProcessCondition = 5
}

export function GetTodoRequestFromJSON(json: any): GetTodoRequest {
    return GetTodoRequestFromJSONTyped(json, false);
}

export function GetTodoRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTodoRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
        'offset': !exists(json, 'offset') ? undefined : json['offset'],
        'showFuture': !exists(json, 'ShowFuture') ? undefined : json['ShowFuture'],
        'divider': !exists(json, 'divider') ? undefined : json['divider'],
        'todotype': !exists(json, 'todotype') ? undefined : json['todotype'],
        'getcount': !exists(json, 'getcount') ? undefined : json['getcount'],
        'hash': !exists(json, 'hash') ? undefined : json['hash'],
    };
}

export function GetTodoRequestToJSON(value?: GetTodoRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'limit': value.limit,
        'offset': value.offset,
        'ShowFuture': value.showFuture,
        'divider': value.divider,
        'todotype': value.todotype,
        'getcount': value.getcount,
        'hash': value.hash,
    };
}


